import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "steps__step-number" }
const _hoisted_2 = { class: "steps__step-title-wrapper" }
const _hoisted_3 = { class: "steps__step-title" }
const _hoisted_4 = {
  key: 0,
  class: "steps__step-form"
}
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = {
  key: 0,
  class: "project-review"
}
const _hoisted_7 = { class: "project-review__total" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Total cost", -1 /* HOISTED */)
const _hoisted_9 = { class: "project-review__total-amount" }
const _hoisted_10 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["steps__step", ( $setup.is_completed_step ) ? ' steps__step--completed' : ( $setup.is_current_step ) ? ' steps__step--active' : null])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString($props.step.step_number), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString($props.step.title), 1 /* TEXT */)
    ]),
    ($setup.is_current_step)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _withModifiers($setup.updateForm, ["prevent"])
          }, [
            ($setup.total)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString($setup.total), 1 /* TEXT */)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              class: _normalizeClass(["button button--fill", { 'button--loading': $setup.loading}]),
              type: "submit",
              disabled: $setup.loading
            }, " Add Scope ", 10 /* CLASS, PROPS */, _hoisted_10)
          ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}